import React, { Component, Fragment } from "react";
import autobind from "autobind-decorator";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import Route from "../../Routes";
import http from "../../services/HttpService";
import i18next from 'i18next';
import { Translation } from "react-i18next";
import Loading from "../includes/Loading";
import Login from "../pages/Auth/Login";
import Register from "../pages/Auth/Register";
import ForgotPassword from "../pages/Auth/ForgotPassword";



import {
    Collapse,
    Navbar,
    NavbarToggler,
    NavbarBrand,
    Nav,
    NavItem,
    NavLink,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Container,
    Row,
    Col,
    InputGroup,
    InputGroupAddon,
    Button,
    Input,
    UncontrolledTooltip,
   
} from 'reactstrap';

import Logo_b  from "../../../assets/img/site/Logo.png";
import Logo_w  from "../../../assets/img/site/Logo-1.png";
import Logo_1  from "../../../assets/img/site/orange/Asset-42.svg";
import Logo_2  from "../../../assets/img/site/orange/Asset-43.svg";
import Header from "../pages/Header";
import SearchBoard from "../pages/SearchBoard";
import Footer from "../pages/Footer"
//import {AUTH_LOGIN} from "../../store/actions";
//import validate from "../../services/ValidationService";

const mapState = (state) => {
    return {
        isLogged: state.AuthReducer.isLogged,
        user: state.AuthReducer.user,
    };
};

@(connect(mapState) as any)
export default class Master extends Component<any> {
    static propTypes = {
        dispatch: PropTypes.func.isRequired
    };

    state = {
        openedCollapse: {},
        openedCollapse1: {},
        openedCollapse2: {},
        openedCollapse3: {},
        openedCollapse4: {},
        openedCollapse5: {},

        collapsed: true,
        lng: i18next.language,
        languages:[],
        tools:[]

    };

    constructor(props: Map<any, any>) {
        super(props);
    }

    componentDidMount() {
        // http.get('/site/languages')
        //     .then(response => response.json())
        //     .then((data) => {
        //         this.setState({
        //             languages: data.languages,
        //         });
        //     });
    }

    @autobind
    toggleMenuCollapse(event, key) {
        event.preventDefault();
        const { openedCollapse, openedCollapse1,openedCollapse5 } = this.state;

        openedCollapse1['components-1'] = false;
        openedCollapse5['components-5'] = false;
        if(!openedCollapse.hasOwnProperty(key)){
            openedCollapse[key] = false;
        }
        openedCollapse[key] = !openedCollapse[key];

        this.setState({
            openedCollapse5,
            openedCollapse,
            openedCollapse1,
        });
    }

    @autobind
    toggleMenuCollapse1(event, key) {
        event.preventDefault();
        const { openedCollapse, openedCollapse1 } = this.state;

        openedCollapse['components-0'] = false;
        if(!openedCollapse1.hasOwnProperty(key)){
            openedCollapse1[key] = false;
        }
        openedCollapse1[key] = !openedCollapse1[key];
        this.setState({
            openedCollapse1,
            openedCollapse,
        });
    }

    @autobind
    toggleMenuCollapse2(event, key) {
        event.preventDefault();
        const { openedCollapse, openedCollapse1, openedCollapse2 } = this.state;

        openedCollapse['components-0'] = false;
        openedCollapse1['components-1'] = false;
        if(!openedCollapse2.hasOwnProperty(key)){
            openedCollapse2[key] = false;
        }
        openedCollapse2[key] = !openedCollapse2[key];
        this.setState({
            openedCollapse2,
            openedCollapse1,
            openedCollapse,
        });
    }

    @autobind
    toggleMenuCollapse3(event, key, key1) {
        event.preventDefault();
        const { openedCollapse, openedCollapse1, openedCollapse2, openedCollapse3, openedCollapse4 } = this.state;
        const {isLogged, user}=this.props;

        openedCollapse['components-0'] = false;
        openedCollapse1['components-1'] = false;
        openedCollapse2['components-2'] = true;
        openedCollapse4['components-4'] = false;

        if(!openedCollapse3.hasOwnProperty(key)){
            openedCollapse3[key] = false;
        }
        openedCollapse3[key] = !openedCollapse3[key];

        this.setState({
            openedCollapse4,
            openedCollapse3,
            openedCollapse2,
            openedCollapse1,
            openedCollapse,
        });
    }

    @autobind
    toggleMenuCollapse4(event, key) {
        event.preventDefault();
        const { openedCollapse, openedCollapse1, openedCollapse2, openedCollapse3, openedCollapse4} = this.state;
        const {isLogged, user}=this.props;

        openedCollapse['components-0'] = false;
        openedCollapse1['components-1'] = false;
        openedCollapse2['components-2'] = true;
        openedCollapse3['components-3'] = true;

        if(!openedCollapse4.hasOwnProperty(key)){
            openedCollapse4[key] = false;
        }
        openedCollapse4[key] = !openedCollapse4[key];

        http.get(`/users/getUsersTool/${user.id}`)
            .then(response => response.json())
            .then((data) => {
                this.setState({
                    tools:data
                });
            });

        this.setState({
            openedCollapse4,
            openedCollapse3,
            openedCollapse2,
            openedCollapse1,
            openedCollapse,
        });
    }

    @autobind
    toggleMenuCollapse5(event, key) {
        event.preventDefault();
        const { openedCollapse, openedCollapse1, openedCollapse2, openedCollapse3, openedCollapse4, openedCollapse5} = this.state;
        const {isLogged, user}=this.props;

        openedCollapse['components-0'] = false;
        openedCollapse1['components-1'] = false;
        openedCollapse3['components-3'] = false;
        openedCollapse3['components-4'] = false;

        if(!openedCollapse5.hasOwnProperty(key)){
            openedCollapse5[key] = false;
        }
        openedCollapse5[key] = !openedCollapse5[key];


        this.setState({
            openedCollapse5,
            openedCollapse4,
            openedCollapse3,
            openedCollapse2,
            openedCollapse1,
            openedCollapse,
        });
    }

    @autobind
    changeLanguage(e) {
        const lng = e.currentTarget.dataset.lang
        this.setState({ lng: lng }, () => {
            i18next.changeLanguage(lng);
            this.props.changeLang();
        });
    }

    @autobind
    langTranslation(e){
        return <Translation>{t => t(`${e}`)}</Translation>
    }

    render() {
        const {isLogged, user}=this.props;
        const {
            languages,
            openedCollapse,
            openedCollapse1,
            openedCollapse2,
            openedCollapse3,
            openedCollapse4,
            openedCollapse5,
            tools
        }=this.state;

        //console.log("openedCollapse-",openedCollapse);
        //console.log("openedCollapse5-",openedCollapse5);

        return (
            <div className="wrapper">
                {/*Header*/}

                <Header/>
               
                {/*Content*/}
                {this.props.children}

                {/*Footer*/}
                <div>
                <Footer/>
                </div>
              
            </div>
        )

    }
}
